module.exports = __webpack_public_path__ + "assets/img/45_douyin_100x100.80873db8.png";